import React from "react";
import GeneralStrings from "../../../strings/GeneralStrings.json";
import { Field } from "formik";
import FormikRadioGroup from "../../FormikRadioGroup/FormikRadioGroup";

const NumberOfLessonsStep = () => {
  const NUMBER_OF_LESSONS_STEP_STRINGS =
    GeneralStrings.ENROLL.FORM_LABELS.NUMBER_OF_LESSONS_STEP;
  const options = ["1", "2", "3", "4"];

  return (
    <div className="step">
      <h4 className="step-header">{NUMBER_OF_LESSONS_STEP_STRINGS.HEADER}</h4>
      <div className="question-container">
        <Field
          className="form-group"
          name="numberOfLessonsPerWeek"
          options={options}
          component={FormikRadioGroup}
        />
      </div>
    </div>
  );
};

export default NumberOfLessonsStep;
